import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import AuthForm from "../components/AuthForm";
import InputField from "../components/InputField";
import Checkbox from "../components/Checkbox";
import Button from "../components/Button";
import Spinner from "../components/Spinner";
import { showToast } from "../components/ToastNotification";
import { FaEnvelope, FaLock } from "react-icons/fa";
import analytics from "../services/analytics";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useContext(AuthContext);

    const handleLogin = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/signin`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || "Login failed.");

            // Pass refresh token to login function
            login(data.access_token, data.refresh_token, rememberMe, data.user_id, data.data);
            
            // Track successful login
            analytics.trackLogin('email');
            analytics.setUserId(data.user_id);

            const planRes = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/stripe/plan-status`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${data.access_token}`,
                },
            });

            const planData = await planRes.json();
            if (!planRes.ok) throw new Error("Failed to fetch plan status");

            // Save plan status locally
            const storage = rememberMe ? localStorage : sessionStorage;
            storage.setItem("plan_status", JSON.stringify(planData));

            // Redirect to dashboard instead of direct tools
            navigate("/dashboard");

        } catch (err) {
            showToast(err.message, "error");
            analytics.trackFormSubmit('login', false);
        } finally {
            setLoading(false);
        }
    };

    // Google Sign-In is disabled for now due to client ID configuration issues
    // const handleSignInWithGoogle = async (response) => {
    //     const { data, error } = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/signin/google`, {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({ token: response.credential }),
    //     });
    // }

    return (
        <>
            <Spinner loading={loading} />
            <AuthForm title="Welcome Back!">
                <InputField
                    label="Email Address *"
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    icon={FaEnvelope}
                />
                <InputField
                    label="Password *"
                    type="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    icon={FaLock}
                />
                <Checkbox
                    label="Keep me logged in"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                />
                <Button text="Log In" fullWidth onClick={handleLogin} />
                <p className="mt-4 text-center text-gray-600">
                    <Link to="/auth/forgot-password" className="text-blue-600">Forgot your password?</Link>
                </p>
                <p className="mt-2 text-center">
                    New to our platform? <Link to="/auth/signup" className="text-blue-600">Create an account</Link>
                </p>
            </AuthForm>
        </>
    );
};

export default Login;
